import React from "react";
import EditBook from "../../img/EditBook.png";
// import Filters from "./Filters";
import {Link} from "react-router-dom";
import axios from "axios";
import {connect} from "react-redux";
import {Accordion, Card} from "react-bootstrap";
import {fetch_booklists} from "./action/books.js";

class MyBooksPage extends React.Component{
    constructor(props) {
      super(props);
      this.state = {
         "ov": false,
         "books": props.booklists
      };
    }
    render(){
        const {booklists} = this.props;
        const {addToBookList, removeBookList} = this;
        return(
            <div>
                    {this.state.books !== [] ?
                    this.state.books.map(function(item){
                        return <Book bookListId={item.bookListId} description={item.booklist_description} total_noof_books={item.total_noof_books} booklist_title={item.booklist_title}/>
                    }):<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    }
            </div>
        );
    }
};

const Book = (props) => {
    return(
        <Accordion>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              {props.booklist_title}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <div className="bookl">
        <Link to={"/main/bookLists/"+props.bookListId} className="pagalHain">
            <div className="right2Section">
                <h2 className="book_title">{props.booklist_title}</h2>
                <div className="total_section">
                    <h6>Total Number Of Books: <b>{props.total_noof_books}</b></h6>
                </div>
                <p className="description">{props.description.substring(0, 95)} {props.description.length > 94 && (<span className="text-danger"><b><u>Read More...</u></b></span>)}</p>
            </div>
        </Link>
            <div className="editBooklist">
                <Link to={"/main/editBookL/"+props.bookListId}><img src={EditBook} alt="Edit Book" className="editBook" /></Link>
            </div>

            <Link to={"/main/bookLists/"+props.bookListId} className="footerright">
                <div className="expandLi"></div>
            </Link>
            </div>
            </Accordion.Collapse>
          </Card>
        </Accordion>
    )
}

function mapStateToProps(state){
    return {
        isAuthenticated: !!state.user.name, 
        books: state.AllBooks.books, 
        booklists: state.AllBooklists.bookLists, 
        searchedContents: state.SearchBook.books,
        length: state.SearchBook.length
    }
}

export default connect(mapStateToProps, {fetch_booklists})(MyBooksPage);